import { ScanLine } from "lucide-react";
import { Button } from "../ui/Button";

interface ScanImportButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/** Toolbar-knop "Scan / import" — opent de ScanImportModal. Wordt in de
 *  DataTable-toolbar geplaatst naast de export-knoppen (CSV/PDF/Mail). */
export function ScanImportButton({ onClick, disabled }: ScanImportButtonProps) {
  return (
    <Button variant="outline" onClick={onClick} disabled={disabled} className="whitespace-nowrap">
      <ScanLine size={20} /> Scan / import
    </Button>
  );
}